import {
    apiTokenService,
    AuthContext,
    getTemplate
} from "@harvestr-api/common";
import { logger } from "@harvestr-api/utils";
import base64url from "base64url";
import { Request, Response } from "express";
import { OAuth2 } from "oauth";
import * as request from "request";
import * as url from "url";
import { gitlabApiService } from "./gitlab-api.service";

// Gitlab redirects the user here after authentication
const gitlabCloudKey = process.env.GITLAB_OAUTH_CLIENT_ID;
const gitlabCloudSecret = process.env.GITLAB_OAUTH_CLIENT_SECRET;
const gitlabCloudBaseSite = `https://gitlab.com`;

const gitlabLoginCallback = `${
    process.env.H_API_URL || ""
}/authorize/gitlab/callback`;

const gitlabOauthScope = "api read_user read_repository";
const gitlabAuthorizeUrl = "oauth/authorize";
const gitlabAccessUrl = "oauth/token";

const _getGitlabConsumer = async (domain, appId, appSecret) => {
    const consumer = new OAuth2(
        appId,
        appSecret,
        domain + "/",
        gitlabAuthorizeUrl,
        gitlabAccessUrl,
        null
    );
    return consumer;
};

export const gitlabOauthService = {
    async handleGitlabOauth(req: Request, res: Response) {
        try {
            logger.info(gitlabCloudKey);
            logger.info(gitlabLoginCallback);
            const subdomain = req.query.subdomain;
            const _req: any = req;

            const project_id = req.query.id;
            logger.info("subdomain :", subdomain);
            const domainOrSub = req?.query?.subdomain
                ? `https://${req?.query?.subdomain}`
                : gitlabCloudBaseSite;
            const gitlab_consumer = await _getGitlabConsumer(
                domainOrSub,
                req?.query?.appId || gitlabCloudKey,
                req?.query?.appSecret || gitlabCloudSecret
            );

            if (_req?.query?.appId && req?.query?.appSecret) {
                _req.session.hostUrl = _req?.query?.subdomain;
                _req.session.appId = _req?.query?.appId;
                _req.session.appSecret = _req?.query?.appSecret;
            }

            const gitlab_authorize_full_URL = gitlab_consumer.getAuthorizeUrl({
                response_type: "code",
                scope: gitlabOauthScope,
                redirect_uri: gitlabLoginCallback,
                state: base64url(
                    JSON.stringify({
                        project_id,
                        subdomain: subdomain || gitlabCloudBaseSite
                    })
                )
            });
            logger.info(gitlab_authorize_full_URL);
            res.redirect(gitlab_authorize_full_URL);
        } catch (error) {
            logger.error(error);
            res.status(400).send(error);
        }
    },

    async handleGitlabOauthResponse(req: Request, res: Response) {
        function destroySession() {
            const _req: any = req;
            delete _req.session.hostUrl;
            delete _req.session.appId;
            delete _req.session.appSecret;
        }

        try {
            const query: any = url.parse(req.url, true).query || {};
            const code = query.code;
            const { project_id, subdomain } = JSON.parse(
                base64url.decode(req.query.state as string)
            );
            console.log(project_id, subdomain);
            if (!project_id) {
                throw new Error("No project id found");
            }
            const context: AuthContext = {
                type: "INTEGRATION_GITLAB",
                project_id
            };
            const session = (req as any)?.session;
            const accessUrl =
                (session?.hostUrl
                    ? `https://${session?.hostUrl}`
                    : gitlabCloudBaseSite) +
                "/" +
                gitlabAccessUrl;

            request.post(
                {
                    url: accessUrl,
                    form: {
                        client_id:
                            session?.hostUrl && session?.appId
                                ? session?.appId
                                : gitlabCloudKey,
                        client_secret:
                            session?.hostUrl && session?.appSecret
                                ? session?.appSecret
                                : gitlabCloudSecret,
                        code,
                        grant_type: "authorization_code",
                        redirect_uri: gitlabLoginCallback
                    }
                },
                async (error, httpResponse, stringBody) => {
                    try {
                        if (error) {
                            throw new Error(error.data);
                        }
                        console.log("string_body : ", stringBody);
                        const body: {
                            access_token?: string;
                            token_type?: string;
                            refresh_token?: string;
                            scope?: string;
                            created_at?: number;
                        } = JSON.parse(stringBody);
                        const hasUserRightAccessLevel = await gitlabApiService.hasUserRequiredPermissions(
                            {},
                            context,
                            body.access_token,
                            subdomain
                        );
                        if (!hasUserRightAccessLevel) {
                            throw new Error("not_enough_permissions");
                        }
                        await apiTokenService.createApiToken(
                            {
                                source: "GITLAB",
                                token: body.access_token,
                                host_url:
                                    subdomain === gitlabCloudBaseSite
                                        ? undefined
                                        : subdomain,
                                appId: session?.appId,
                                appSecret: session?.appSecret
                            },
                            context
                        );
                        destroySession();
                        res.status(200).send(
                            "<h3>Success! Redirecting...</h3><h4>You can close this window.</h4>"
                        );
                    } catch (err) {
                        destroySession();
                        if (err.message === "not_enough_permissions") {
                            res.status(400).send(
                                getTemplate("gitlab_not_enough_permissions")
                            );
                        } else {
                            logger.error(err);
                            throw new Error("error getting access token");
                        }
                    }
                }
            );
        } catch (error) {
            logger.error(error);
            res.status(400).send(`<h3>Error: </h3>${error}`);
        }
    }
};
